import { v4 } from 'uuid';
import { isCardRef } from '../shared/index.js';
import { dealCards } from './commands/dealCards.js';
import { defaultOptions, init } from './commands/init.js';
import { placeBid } from './commands/placeBid.js';
import { playCard, choosePlayableCards } from './commands/playCard.js';
import { getOhHellPlayerState, } from './state/playerState.js';
import { isSuccess, OhHellEventName, OhHellCmdType, getTrickWinnerId, } from './state/state.js';
import { kickPlayer } from './commands/kickPlayer.js';
export { ExpertIds } from './expert/shared.js';
export { getTrickWinnerId, choosePlayableCards };
export { OhHellCmdType };
const getGameEvent = (game, event) => ({
    eventId: v4(),
    gameId: game.gameId,
    eventType: event.eventName,
    eventData: event.details,
});
const handleOhHellResult = (game, result) => {
    if (isSuccess(result)) {
        return {
            game: { ...game, gameState: result.state },
            events: result.events.map((event) => getGameEvent(game, event)),
        };
    }
    throw new Error(result.message);
};
export const OhHellHandlers = {
    start: (prevGame, cmd) => {
        const cmdData = (cmd.cmdData || {});
        const options = { ...defaultOptions, ...cmdData };
        if (!options.deckCode || !options.rounds) {
            throw new Error('invalid options for start OhHell');
        }
        const gameState = init(prevGame.players, prevGame.hostUserId, options);
        const startEvent = getGameEvent(prevGame, {
            eventName: OhHellEventName.Start,
            details: {},
        });
        return {
            game: { ...prevGame, gameState },
            events: [startEvent],
        };
    },
    getPlayerState: (prevGame, cmd) => {
        if (!cmd?.player?.userId) {
            throw new Error('must provide player to getPlayerState in cmd');
        }
        const playerId = cmd.player.userId;
        const state = prevGame.gameState;
        if (!state?.currentRound || !state?.currentRound?.hands?.length) {
            return { game: { ...prevGame, gameState: state }, events: [] };
        }
        const ohHellState = getOhHellPlayerState(state, playerId);
        return { game: { ...prevGame, gameState: ohHellState }, events: [] };
    },
    dealCards: (prevGame, cmd) => {
        const deal = cmd?.cmdData;
        if (!deal?.playerId) {
            throw new Error(`missing deal data in DealCards; cmd was ${JSON.stringify(cmd)} `);
        }
        const result = dealCards(prevGame.gameState, deal);
        return handleOhHellResult(prevGame, result);
    },
    placeBid: (prevGame, cmd) => {
        const bid = cmd?.cmdData;
        if (!bid || (!bid.bidTricks && bid.bidTricks !== 0) || !bid.playerId) {
            throw new Error(`missing bid data in placeBid; cmd was ${JSON.stringify(cmd)} `);
        }
        const result = placeBid(prevGame.gameState, bid);
        return handleOhHellResult(prevGame, result);
    },
    playCard: (prevGame, cmd) => {
        const card = cmd?.cmdData;
        if (!card || !isCardRef(card.card) || !card.playerId) {
            throw new Error(`missing card data in playCard; cmd was ${JSON.stringify(cmd)} `);
        }
        const result = playCard(prevGame.gameState, card);
        return handleOhHellResult(prevGame, result);
    },
    kickPlayer: (prevGame, cmd) => {
        const kickData = cmd.cmdData;
        if (!kickData) {
            throw new Error(`missing kick player data in kickPlayer; cmd was ${JSON.stringify(cmd)} `);
        }
        const result = kickPlayer(prevGame.gameState, kickData);
        return handleOhHellResult(prevGame, result);
    },
};
//# sourceMappingURL=OhHell.js.map